import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CallInboundTheme } from 'modules/theme';
import { globalStateSelector } from 'store/selector';
import { messageAction } from 'store/action';

export class CallInbound extends Component {
  constructor(props){
    super(props);
    this.onClickAcceptBtn = this.onClickAcceptBtn.bind(this);
    this.onClickDeclineBtn = this.onClickDeclineBtn.bind(this);
  }
  onClickAcceptBtn(){
    const { answerCall } = this.props;
    answerCall();
  }
  onClickDeclineBtn(){
    const { rejectCall } = this.props;
    rejectCall();
  }
  render() {
    const { currentUser, isOffer } = this.props;
    // let hideButton = (!currentUser || !currentUser.phoneType || currentUser.phoneType != "web") ? true : false;
    let hideButton = true;
    let message = "InComming Call";
    if( isOffer ){
      message = "Please Answer Your Call";
      hideButton = false;
    }
    return (
      <CallInboundTheme
        message={message}
        onClickAcceptBtn={this.onClickAcceptBtn}
        hideButton={hideButton}
        acceptBtn={'images/call-accept.svg'}
        acceptText={'Accept'}
        onClickDeclineBtn={this.onClickDeclineBtn}
        declineBtn={'images/call-decline.svg'}
        declineText={'Decline'}
      />
    )
  }
}

CallInbound.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  userState: globalStateSelector.getState(state),
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' }),
  isOffer: globalStateSelector.getDynamic(state, { key: 'isOffer' }),
});

const dispatchToProps = dispatch => ({
  answerCall: () => {
    dispatch(messageAction.answerCall());
  },
  rejectCall: () => {
    dispatch(messageAction.rejectCall());
  }
});

export default connect(stateToProps, dispatchToProps)(CallInbound);



// WEBPACK FOOTER //
// src/dialpad/components/layout/CallInbound.js